let config = {
  back: {
    url: 'https://back.pikontrol.infometrika.com',
    toolbarMsg: '',
    dialog: false,
    color: 'primary',
    message: ''
  },
  appName: 'iKontrol',
  logo: 'https://files.infometrika.com/Images/ik.svg'
}

export default config
